import get from "lodash/get";
import mixin_address_form from "@/mixins/address/form";

export default {
    mixins: [mixin_address_form],
    methods: {
        address_isIncompleted(address, {tags}) {

            tags = "undefined" === typeof tags ? [] : tags;

            return true === address.incomplete
                || (
                    0 < tags.length
                    && this.$store.getters["user/address/config"].reduce(
                        (isIncompleted, field) => true === isIncompleted
                            || (
                                false === isIncompleted
                                && !address[field.field]
                                && field.validation
                                && field.validation.required
                                && "undefined" !== typeof field.tags
                                && 0 < field.tags.length
                                && 0 < field.tags.filter(fieldTag => -1 !== tags.indexOf(fieldTag)).length
                            ),
                        false
                    )
                );
        },
        address_getTextRepresentation(address, tags = []) {

            return this.$store.getters["user/address/config"].reduce(
                (result, field) => {

                    if (
                        (
                            "undefined" === typeof field.tags
                            || 0 < field.tags.filter(fieldTag => -1 !== tags.indexOf(fieldTag)).length
                        )
                        && address[field.field]
                    ) {

                        let fieldValue = address[field.field];

                        if ("dropdown" === field.type) {

                            fieldValue = get(
                                this.address_form_getAddressFieldOption(field, fieldValue),
                                "name",
                                fieldValue
                            );
                        }

                        if ("undefined" === typeof field.tags) {

                            result.push(fieldValue);
                        } else {

                            const label = this.address_form_getAddressFieldTranslation(
                                field,
                                "label",
                                this.$store.getters["user/profile/country"]
                            );

                            result.push(`${label}: ${fieldValue}`);
                        }
                    }

                    return result;
                },
                []
            );
        }
    }
}